// extracted by mini-css-extract-plugin
export default {"spinner":"Loading_spinner__JkmWW","rotate":"Loading_rotate__n7LtR"};